/* ============================================
   MSpa "Coming Soon" Landing Page — JS
   Portable Spas New Zealand — 2026
   ============================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Hero entrance sequence --- */
  function initHeroSequence() {
    var hero = document.querySelector('.mspa-hero');
    if (!hero) return;
    if (prefersReducedMotion) {
      hero.classList.add('mspa-hero--entered');
      return;
    }
    setTimeout(function () {
      hero.classList.add('mspa-hero--entered');
    }, 300);
  }

  /* --- Scroll-triggered reveal animations --- */
  function initScrollAnimations() {
    var els = document.querySelectorAll('.mspa-reveal');
    if (!els.length) return;

    if (prefersReducedMotion) {
      els.forEach(function (el) { el.classList.add('mspa-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mspa-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --- Lightweight parallax for lifestyle images --- */
  function initParallax() {
    if (prefersReducedMotion) return;

    var images = document.querySelectorAll('.mspa-product__lifestyle-img');
    if (!images.length) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          images.forEach(function (img) {
            var parent = img.parentElement;
            var rect = parent.getBoundingClientRect();
            var windowH = window.innerHeight;
            if (rect.bottom > 0 && rect.top < windowH) {
              var progress = (rect.top + rect.height) / (windowH + rect.height);
              var translate = (progress - 0.5) * -200;
              img.style.transform = 'translateY(' + translate + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Video player --- */
  function initVideoPlayers() {
    var players = document.querySelectorAll('.mspa-video__player');
    players.forEach(function (player) {
      player.addEventListener('click', function () {
        var src = player.getAttribute('data-video-src');
        if (!src) return;

        if (src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1) {
          var iframe = document.createElement('iframe');
          iframe.src = src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
          iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none;';
          iframe.setAttribute('allow', 'autoplay; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          player.style.position = 'relative';
          player.innerHTML = '';
          player.appendChild(iframe);
        } else {
          var video = document.createElement('video');
          video.src = src;
          video.controls = true;
          video.autoplay = true;
          video.style.cssText = 'width:100%;height:100%;object-fit:cover;';
          player.innerHTML = '';
          player.appendChild(video);
        }
      });
    });
  }

  /* --- Stagger assignment --- */
  function assignStagger() {
    var groups = document.querySelectorAll('[data-mspa-stagger-group]');
    groups.forEach(function (group) {
      var children = group.querySelectorAll('.mspa-reveal');
      children.forEach(function (child, i) {
        child.style.setProperty('--mspa-stagger', i);
      });
    });
  }

  /* --- Video tabs --- */
  function initVideoTabs() {
    var tabs = document.querySelectorAll('.mspa-video__tab');
    var panels = document.querySelectorAll('.mspa-video__panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-mspa-tab');

        // Pause any playing video in current panel
        var activePanel = document.querySelector('.mspa-video__panel--active');
        if (activePanel) {
          var vid = activePanel.querySelector('video');
          if (vid) vid.pause();
        }

        tabs.forEach(function (t) { t.classList.remove('mspa-video__tab--active'); });
        panels.forEach(function (p) { p.classList.remove('mspa-video__panel--active'); });

        tab.classList.add('mspa-video__tab--active');
        var panel = document.querySelector('[data-mspa-panel="' + target + '"]');
        if (panel) panel.classList.add('mspa-video__panel--active');
      });
    });
  }

  /* --- Product image galleries --- */
  function initProductGalleries() {
    var galleries = document.querySelectorAll('[data-mspa-gallery]');
    galleries.forEach(function (gallery) {
      var imgs = gallery.querySelectorAll('.mspa-product__gallery-img');
      var thumbs = gallery.querySelectorAll('.mspa-product__gallery-thumb');
      if (imgs.length < 2) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-mspa-thumb'), 10);
          imgs.forEach(function (img) { img.classList.remove('mspa-product__gallery-img--active'); });
          thumbs.forEach(function (t) { t.classList.remove('mspa-product__gallery-thumb--active'); });
          imgs[idx].classList.add('mspa-product__gallery-img--active');
          thumb.classList.add('mspa-product__gallery-thumb--active');
        });
      });
    });
  }

  /* --- Init --- */
  function init() {
    // Signal that JS is running — enables CSS animations
    var wrapper = document.querySelector('.mspa-launch');
    if (wrapper) wrapper.classList.add('mspa-js');

    assignStagger();
    initHeroSequence();
    initScrollAnimations();
    initParallax();
    initVideoPlayers();
    initVideoTabs();
    initProductGalleries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
